module.exports = __webpack_public_path__ + "static/media/whitehelmet.b77216d2.svg";